import React, { useState } from 'react';
import NavBar from "../NavBar/NavBar";
import { Button, Col, Container, Row } from "react-bootstrap";
import { IconButton, InputAdornment, TextField, Snackbar, Alert } from "@mui/material";
import Footer from "../Footer/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { db } from "../../FireBase/firestore";
import { collection, addDoc, query, where, getDocs } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";

const CreateAccount = () => {
    const isTablet = window.innerWidth >= 768 && window.innerWidth <= 834;
    const isMobile = window.innerWidth <= 440;
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [reEnterPassword, setReEnterPassword] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showReEnterPassword, setShowReEnterPassword] = useState(false);
    const [snackbar, setSnackbar] = useState({open: false, severity: 'success', message: ''});
    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };
    const showMessage = (severity, message) => {
        setSnackbar({ open: true, severity, message });
    };
    const onClickCreateAccount = async () => {
        if (!email.trim()) {
            showMessage('error', 'Please enter your E-mail');
            return;
        }
        else if (!/^\S+@\S+\.\S+$/.test(email)) {
            showMessage('error', 'Enter a valid email address');
            return;
        }
        if (!password.trim()) {
            showMessage('error', 'Please enter your Password');
            return;
        }
        if (!reEnterPassword.trim()) {
            showMessage('error', 'Please enter your Re-Enter Password');
            return;
        }
        if (!firstName.trim()) {
            showMessage('error', 'Please enter your First Name');
            return;
        }
        if (!lastName.trim()) {
            showMessage('error', 'Please enter your Last Name');
            return;
        }
        if (password !== reEnterPassword) {
            showMessage('error', 'Passwords do not match');
            return;
        }
        try {
            setLoading(true);
            // check if email already exists
            const q = query(
                collection(db, "users"),
                where("email", "==", email)
            );
            const querySnapshot = await getDocs(q);
            if (!querySnapshot.empty) {
                setLoading(false);
                showMessage("error", "Email already in use");
                return;
            }
            // if not exists, create account
            await addDoc(collection(db, "users"), {
                firstName,
                lastName,
                email,
                password,
                createdAt: new Date()
            });
            setLoading(false);
            showMessage('success', 'Account created successfully!');
            setTimeout(() => {
                navigate("/login");
            }, 2000);
        } catch (error) {
            setLoading(false);
            showMessage('error', error.message);
        }
    };

    return (
        <div className="bg-offWhite p-0">
            <NavBar />
            <div style={{ paddingTop: isMobile ? "6rem" : isTablet ? "0" : "12rem"}}>
                <Container className="d-flex justify-content-center align-items-center min-vh-100">
                    <Row className="w-100 justify-content-center">
                        <Col md={6} lg={5}>
                            <div className="p-4 shadow" style={{ backgroundColor: '#fff', borderRadius: '20px' }}>
                                <div className="d-flex justify-content-center">
                                    <h2 className="text-green fw-bold pt-3">CREATE ACCOUNT</h2>
                                </div>
                                <Col>
                                    <Col lg={12} className="mb-4 mt-5">
                                        <TextField label="First Name *" value={firstName} onChange={(e) => setFirstName(e.target.value)} className="w-100"/>
                                    </Col>
                                    <Col lg={12} className="mb-4">
                                        <TextField label="Last Name *" value={lastName} onChange={(e) => setLastName(e.target.value)} className="w-100"/>
                                    </Col>
                                    <Col lg={12} className="mb-4">
                                        <TextField label="E-mail *" value={email} onChange={(e) => setEmail(e.target.value)} className="w-100"/>
                                    </Col>
                                    <Col lg={12} className="mb-4">
                                        <TextField label="Password *" type={showPassword ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} className="w-100"
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton onClick={() => setShowPassword(!showPassword)}>
                                                            <FontAwesomeIcon className="text-green fs-15" icon={showPassword ? faEye : faEyeSlash} />
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Col>
                                    <Col lg={12} className="mb-4">
                                        <TextField label="Re-Enter Password *" type={showReEnterPassword ? "text" : "password"} value={reEnterPassword} onChange={(e) => setReEnterPassword(e.target.value)} className="w-100"
                                             InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton onClick={() => setShowReEnterPassword(!showReEnterPassword)}>
                                                            <FontAwesomeIcon className="text-green fs-15" icon={showReEnterPassword ? faEye : faEyeSlash} />
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Col>
                                    <Button style={{ backgroundColor: '#A6CE3A', borderColor: '#A6CE3A' }} className="w-100 rounded-pill fw-bold text-white" onClick={onClickCreateAccount} disabled={loading}>
                                        {loading ? <CircularProgress size={24} color="inherit" /> : "CREATE ACCOUNT"}
                                    </Button>
                                </Col>
                            </div>
                        </Col>
                    </Row>
                </Container>
                <Footer />
            </div>
            <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
                <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} variant="filled" sx={{ width: '100%' }}>{snackbar.message}</Alert>
            </Snackbar>
        </div>
    );
};
export default CreateAccount;
